<template>
  <!-- <v-container> -->
  <v-text-field
    label="Оценка (баллы)"
    v-model="lawsScore"
    outlined
    readonly
    filled
  />
  <!-- </v-container> -->
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";

export default {
  name: "TheLawsScore",
  components: {},
  data: () => ({}),
  props: {},
  computed: {
    ...mapGetters({ card: GETTERS.CARD_DATA }),

    lawsScore() {
      const count = (arr, code) =>
        arr.filter((item) => item.startsWith(code)).length;

      const data = this.card.laws || [];
      let value = 0;
      if (!data.find((item) => item === "0")) {
        const total = {};
        total["01"] = count(data, "01");
        total["02"] = count(data, "02");
        total["03"] = count(data, "03");
        total["04"] = count(data, "04");

        if (total["01"] || total["02"] || total["03"] || total["04"]) value = 5;
        if (total["03"] && total["04"]) value = 7;
        if ((total["01"] || total["02"]) && total["03"] && total["04"])
          value = 10;
      }

      if (this.card.lawsScore !== value) {
        this.modify({ lawsScore: value });
      }

      return value;
    },
  },
  methods: {
    ...mapMutations({
      modify: MUTATIONS.MODIFY_CARD_DATA,
    }),
  },
};
</script>
